package games.polyclub.website.frontend.store.pages.skyfactory

import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.bootstrap.components.CardTabs
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.new
import games.polyclub.frontend.lib.react.simplified.tags.div
import games.polyclub.frontend.lib.react.simplified.tags.h3
import games.polyclub.frontend.lib.react.simplified.tags.p
import games.polyclub.frontend.lib.react.simplified.tags.strong
import games.polyclub.frontend.lib.react.utils.classes
import games.polyclub.message.unaryMinus
import games.polyclub.service.payment.api.id.OfferId
import games.polyclub.service.payment.api.id.ProductId
import games.polyclub.website.frontend.store.components.ProductPurchaseForm
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.layout.PageBody
import games.polyclub.website.frontend.store.layout.PageHeader
import games.polyclub.website.frontend.store.pages.product.AccessPassInfo
import games.polyclub.website.frontend.store.pages.product.OriginalMinecraft
import games.polyclub.website.frontend.store.sitemap.PublicSitemap
import react.Props

val SkyFactoryPage = SFC<Props> { _ ->
    addBreadcrumb(PublicSitemap.SKYFACTORY.pathPart, -"GameMods: SkyFactory 4")

    PageHeader {
        title = -"GameMods: SkyFactory 4"
        titleIcon = PublicSitemap.SKYFACTORY.icon
    }
    PageBody {
        Card {
            div("row") {
                div("col-12 col-sm-6") {
                    h3("d-inline-block d-sm-none") {
                        +"GameMods: SkyFactory 4"
                    }
                    SkyFactoryImages()
                }
                ProductPurchaseForm {
                    offerId = OfferId("accessPass.skyfactory")
                    mainProduct = ProductId.SKYFACTORY_ACCESS_PASS
                    title = h3.new {
                        classes = "my-3"
                        with(PublicSitemap.SKYFACTORY.icon!!) {
                            renderIcon()
                        }
                        +Typography.nbsp
                        +"Passe de Acesso do GameMods: SkyFactory 4"
                    }
                    shortDescription = p.new {
                        strong { +"SkyFactory 4" }
                        +" é um modpack de SkyBlock para minecraft 1.12.2 onde o objetivo é sobreviver em uma ilha flutuante com recursos limitados."
                    }
                }
            }
            CardTabs("card-primary mt-4") {
                +"Passe de Acesso"
                AccessPassInfo()
                +"Como Instalar"
                SkyFactoryHowToInstall()
                +"Como Jogar"
                SkyFactoryHowToPlay()
                +"Minecraft Original"
                OriginalMinecraft()
            }
        }
    }
}
